import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import Modal from "./Modal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field =
  "w-full rounded-lg bg-[#101317] border border-[#9AA3AF]/25 px-4 py-3 text-white placeholder:text-[#9AA3AF]/60 focus:outline-none focus:border-[#005EA8] transition-colors duration-300";

export default function AskExpertDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: "", contact: "", question: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.contact || !form.question) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/ask-expert`, form);
      setDone(true);
      toast.success("Question sent. Bill will get back to you soon.");
    } catch {
      toast.error("Something went wrong. Please call us at 512-740-4818.");
    } finally {
      setLoading(false);
    }
  };

  const close = (v) => {
    onOpenChange(v);
    if (!v) setTimeout(() => { setDone(false); setForm({ name: "", contact: "", question: "" }); }, 300);
  };

  return (
    <Modal
      testId="expert-dialog"
      open={open}
      onOpenChange={close}
      title="Ask the Expert"
      subtitle="Ask Bill your HVAC question and get a straight answer, no pressure."
    >
      {done ? (
        <div data-testid="expert-success" className="text-center py-8">
          <CheckCircle2 className="mx-auto text-[#005EA8]" size={48} />
          <h4 className="mt-4 text-2xl text-white">Question received.</h4>
          <p className="mt-2 text-[#9AA3AF]">Bill will get back to you with a straight answer soon.</p>
        </div>
      ) : (
        <form data-testid="expert-form" onSubmit={submit} className="space-y-4">
          <input data-testid="expert-name" className={field} placeholder="Your name" value={form.name} onChange={set("name")} />
          <input data-testid="expert-contact" className={field} placeholder="Email or phone" value={form.contact} onChange={set("contact")} />
          <textarea
            data-testid="expert-question"
            className={`${field} min-h-[120px] resize-none`}
            placeholder="What is your HVAC question?"
            value={form.question}
            onChange={set("question")}
          />
          <button
            data-testid="expert-submit"
            type="submit"
            disabled={loading}
            className="focus-gold w-full py-4 rounded-full font-semibold bg-[#005EA8] text-white hover:bg-[#0a6fbf] transition-colors duration-300 disabled:opacity-70 inline-flex items-center justify-center gap-2"
          >
            {loading ? <><Loader2 className="animate-spin" size={18} /> Sending...</> : "Send My Question"}
          </button>
        </form>
      )}
    </Modal>
  );
}
